import React, { useState } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../Redux/Actions/Auth";
import "./header-page.css";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const isLoginPage = location.pathname === "/login";

  const handleLogout = () => {
    dispatch(logout());
    setMenuOpen(false);
    history.push("/login");
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="ds-header">
      <div className="ds-header__bar">
        {!isLoginPage && (
          <button
            type="button"
            className="ds-header__menu-button"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-expanded={menuOpen}
            aria-controls="ds-navigation"
            aria-label={menuOpen ? "Close menu" : "Open menu"}
          >
            <span />
            <span />
            <span />
          </button>
        )}

        <div className="ds-header__brand">
          <img
            src="/driveshop-logo-white.png"
            alt="DriveShop"
            className="ds-header__logo"
          />
          <span className="ds-header__brand-divider" />
          <span className="ds-header__brand-section">
            Mobile
          </span>
        </div>
      </div>

      {!isLoginPage && (
        <>
          {menuOpen && (
            <nav
              id="ds-navigation"
              className="ds-header__navigation"
              aria-label="Main navigation"
            >
              <NavLink
                exact
                to="/"
                activeClassName="ds-header__nav-active"
                onClick={closeMenu}
              >
                Activity
              </NavLink>

              <NavLink
                to="/vehicles"
                activeClassName="ds-header__nav-active"
                onClick={closeMenu}
              >
                Vehicles
              </NavLink>

              <NavLink
                to="/contacts"
                activeClassName="ds-header__nav-active"
                onClick={closeMenu}
              >
                Contacts
              </NavLink>

              <button
                type="button"
                className="ds-header__logout"
                onClick={handleLogout}
              >
                Sign Out
              </button>
            </nav>
          )}
        </>
      )}
    </header>
  );
}
